module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7MpuVmmNNSVB10xuRphAXM-07cd067b89a4b5c4f9d80e2a13aeebc2.jpg";